// Diagnostic utilities for troubleshooting

const BACKEND_URL = 'http://localhost:5000';

export const diagnostics = {
  async checkBackendConnection() {
    console.log('[DIAG] Checking backend connection...');
    try {
      const response = await fetch(`${BACKEND_URL}/api/health`, {
        method: 'GET'
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('[DIAG] Backend is reachable:', data);
        return {
          connected: true,
          message: 'Backend is running',
          data
        };
      } else {
        console.error('[DIAG] Backend returned error status:', response.status);
        return {
          connected: false,
          message: `Backend returned status ${response.status}`
        };
      }
    } catch (error) {
      console.error('[DIAG] Failed to connect to backend:', error);
      return {
        connected: false,
        message: 'Cannot connect to backend: ' + error.message
      };
    }
  },

  async testLogin(email = 'GL-190', password = 'password') {
    console.log('[DIAG] Testing login with:', email);
    try {
      const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();
      console.log('[DIAG] Login test response:', data);

      if (data.success) {
        return {
          success: true,
          message: 'Login test successful',
          data
        };
      } else {
        return {
          success: false,
          message: data.message || 'Login test failed'
        };
      }
    } catch (error) {
      console.error('[DIAG] Login test error:', error);
      return {
        success: false,
        message: 'Login test failed: ' + error.message
      };
    }
  },

  async runFullDiagnostics() {
    console.log('[DIAG] Running full diagnostics...');
    const results = {
      timestamp: new Date().toISOString(),
      backend: await this.checkBackendConnection(),
      login: null
    };

    if (results.backend.connected) {
      results.login = await this.testLogin();
    }

    console.log('[DIAG] Diagnostics complete:', results);
    return results;
  }
};
